module.exports = __webpack_public_path__ + "static/img/logo.fbf41494.svg";